
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { lAreaData } from '@/const/LAreaData';
import { getDepartmentList, getCustomerDepartmentList } from '@/api/company';
import { UserModule } from '@/store/modules/user';
import Deptlist from '@/components/Department/index.vue'; // 多级部门显示

@Component({
  name: 'DeptDialog',
  components: {
    Deptlist
  }
})
export default class extends Vue {
  @Prop({
    type: Number,
    default: 0
  })
  // 1 排班 添加组 2 排班下一步
  enterType!: Number;
  @Prop({
    type: String,
    default: ''
  })
  // 1 排班 添加组
  titleProp!: Number;

  @Prop({
    type: Number,
    default: 2
  })
  deptType!: Number;
  @Prop({
    type: Number,
    default: 9
  })
  type!: Number;
  @Prop({
    type: Boolean,
    default: false
  })
  isCheckbox?: Boolean;

  @Prop({
    type: String,
    default: '0'
  })
  customerCompanyId!: string;
  @Prop({
    type: String,
    default: '0'
  })
  companyId!: string;
  @Prop({
    type: Boolean,
    default: false
  })
  departmentVisible!: Boolean;
  @Prop({
    type: Array
  })
  checkBoxSelect!: [];
  @Prop({
    type: Object,
    default: () => {}
  })
  radioSelect!: any;

 @Watch('pageData.total', {
   deep: true,
   immediate: true
 })
  handleChangePage() {
    if (this.pageData.total > this.pageData.page) {
      this.moreLoading = true;
    }
  }

  private listQuery = {
    deptmentName: '',
    area: [],
    page: 1
  };
  private listData = [];
  private title = '';
  private loading = false;
  private moreLoading = false;
  private defaultProps: any = {
    children: 'child',
    label: 'name',
    value: 'id'
  };
  private selection:any = {};
  private groupName:any=''
  private checkboxSelected:any = []
  private lAreaData!: any;

  private isCheckboxDept = true
  private isSearchDept = false
  private isDialogDept = true
  private columnItemData: any = [
    { name: '部门名称', value: '0', checked: true },
    { name: '添加时间', value: '1', checked: false },
    { name: '省市区', value: '2', checked: true },
    { name: '操作', value: '3', checked: false }
  ]
  private pageData: any = {
    page: 1,
    total: 0,
    pageSize: 10
  }
  private isAllDept = true
  private deptlistMultipleSelection = []

  created() {
    switch (this.deptType) {
      case 1:
        this.title = '报修部门';
        break;
      case 2:
        this.title = '服务部门';
        break;
      case 9:
        this.title = '所有部门';
        break;
      default:
        break;
    }
    this.lAreaData = lAreaData;
    this.lAreaData.map((item: any) => {
      if (item && item.child && item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item &&
          item.child &&
          item.child.map((temp: any) => {
            if (temp && temp.child && temp.child.length === 0) {
              (temp.child as any) = undefined;
            }
          });
      }
    });
    if (this.isAllDept) {
      this.clear();
    }
  }

  private checkedSelectedChange() {

  }
  resetData() {
    this.selection = '';
    this.listQuery.page = 1;
    this.listQuery.deptmentName = '';
    this.listQuery.area = [];
  }
  getCustomerDeptList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: parseInt(this.companyId) !== 0 ? this.companyId : UserModule.getCompanyId,
      type: this.type,
      dept_type: this.deptType,
      name: this.listQuery.deptmentName,
      page: this.listQuery.page,
      address: this.listQuery.area,
      customer_company_id: parseInt(this.customerCompanyId) !== 0 ? this.customerCompanyId : UserModule.getCompanyId
    };
    getCustomerDepartmentList(params)
      .then((res) => {
        if (
          res.data === null ||
          (res.data && res.data.page_count <= this.listQuery.page)
        ) {
          this.moreLoading = false;
        } else {
          this.moreLoading = true;
        }
        if (res.data) {
          if (this.listQuery.page === 1) {
            this.listData = res.data.list;
          } else {
            this.listData = this.listData.concat(res.data.list);
          }
        } else {
          this.listData = [];
        }
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        let msg = (err.msg);
      });
  }
  getDeptList() {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: parseInt(this.companyId) !== 0 ? this.companyId : UserModule.getCompanyId,
      type: this.type,
      name: this.listQuery.deptmentName,
      page: this.listQuery.page,
      address: this.listQuery.area
    };
    if (parseInt(this.customerCompanyId) > 0) {
      params.customer_company_id = this.customerCompanyId;
    }
    if (this.deptType > 0) {
      params.dept_type = this.deptType;
    }
    getDepartmentList(params)
      .then((res) => {
        if (
          res.data === null ||
          (res.data && res.data.page_count <= this.listQuery.page)
        ) {
          this.moreLoading = false;
        } else {
          this.moreLoading = true;
        }
        if (res.data) {
          if (this.listQuery.page === 1) {
            this.listData = res.data.list;
          } else {
            this.listData = this.listData.concat(res.data.list);
          }
        } else {
          this.listData = [];
        }
        this.loading = false;
        this.setCheckBoxSelect(this.listData);
        this.setRadioSelect(this.listData);
      })
      .catch((err) => {
        this.loading = false;
        let msg = (err.msg);
      });
  }
  private setCheckBoxSelect(list:any) {
    if (this.checkBoxSelect && this.checkBoxSelect.length > 0) {
      for (let index = 0; index < this.checkBoxSelect.length; index++) {
        const element:any = this.checkBoxSelect[index];
        for (let i = 0; i < list.length; i++) {
          const item:any = list[i];
          if (element.department_id === item.id) {
            this.checkboxSelected.push(list[i]);
          }
        }
      }
    }
  }
  private setRadioSelect(list:any) {
    if (this.radioSelect && this.radioSelect.dept_id) {
      for (let i = 0; i < list.length; i++) {
        const item:any = list[i];
        if (this.radioSelect.dept_id === item.dept_id) {
          this.selection = list[i];
        }
      }
      this.groupName = this.radioSelect.groupName;
    }
  }
  search() {
    this.listQuery.page = 1;
    if (this.isAllDept) {
      if (this.deptType === 1) {
        this.getCustomerDeptList();
      } else {
        this.getDeptList();
      }
    } else {
      this.isSearchDept = true;
      (this.$refs.deptlist as any).getDepartmentListAll();
    }
  }
  clear() {
    this.resetData();
    if (this.isAllDept) {
      if (this.deptType === 1) {
        this.getCustomerDeptList();
      } else {
        this.getDeptList();
      }
    } else {
      this.isSearchDept = false;
      (this.$refs.deptlist as any).getDepartmentList(0, 1);
    }
  }
  close() {
    this.$emit('close', false);
    // if (this.deptType === 1) {
    //   this.getCustomerDeptList();
    // } else {
    //   this.getDeptList();
    // }
  }

  private pageTotalData(val: any) {
    this.pageData.total = val;
  }

  moreData() {
    if (this.isAllDept) {
      this.listQuery.page += 1;
      if (this.deptType === 1) {
        this.getCustomerDeptList();
      } else {
        this.getDeptList();
      }
    } else {
      this.pageData.page++;
      if (this.pageData.total - this.pageData.page * this.pageData.pageSize > 0) {
        this.moreLoading = true;
      } else {
        this.moreLoading = false;
      }
      if (this.isSearchDept) {
        (this.$refs.deptlist as any).getDepartmentListAll();
      } else {
        (this.$refs.deptlist as any).getDepartmentList(0, 1);
      }
    }
  }

  private deptlistSelected(val: any) {
    this.deptlistMultipleSelection = val;
  }
  submit() {
    if (this.isAllDept) {
      if (this.isCheckbox) {
        if (!this.checkboxSelected || this.checkboxSelected.length < 1) {
          this.$notify({
            title: '提示',
            message: '请选择部门',
            duration: 3000,
            offset: 100,
            type: 'error'
          });
          return;
        }
        this.$emit('selectDept', this.checkboxSelected);
      } else {
        if (this.enterType === 1) {
          if (!this.groupName) {
            this.$notify({
              title: '提示',
              message: '请输入组名',
              duration: 3000,
              offset: 100,
              type: 'error'
            });
            return;
          }
          if (!this.selection || !this.selection.dept_id) {
            this.$notify({
              title: '提示',
              message: '请选择部门',
              duration: 3000,
              offset: 100,
              type: 'error'
            });
            return;
          }
          this.selection.groupName = this.groupName;
          if (this.enterType === 2) {
            this.$emit('selectDept', this.selection);
          } else {
            this.$emit('selectDept', this.selection);
            this.resetData();
            this.$emit('close', false);
          }
          return;
        }
        if (!this.selection || !this.selection.dept_id) {
          this.$notify({
            title: '提示',
            message: '请选择部门',
            duration: 3000,
            offset: 100,
            type: 'error'
          });
          return;
        }
        if (this.enterType === 2) {
          this.$emit('selectDept', this.selection);
        } else {
          this.$emit('selectDept', this.selection);
          this.resetData();
          this.$emit('close', false);
        }
      }
    } else {
      this.$emit('selectDept', this.deptlistMultipleSelection);
      this.$emit('close', false);
    }
  }
}
